import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {JoinComponent} from '@app/getstarted/join/join.component';
import {LandingComponent} from '@app/getstarted/landing/landing.component';
import {CreateWorkspaceComponent} from '@app/workspace/create-workspace/create-workspace.component';

const routes: Routes = [
    { path: 'get-started/join/:id/:code', component: JoinComponent },
    { path: 'get-started/landing', component: LandingComponent },
    { path: 'get-started/create', component: CreateWorkspaceComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class GetStartedRoutingModule {}
